import { PM_PROVIDERS } from 'common/constants/constants';

export const PRODUCTIVITY_REPORTS = [
  {
    type: 'productivity',
    name: 'Efficiency',
    id: 'productivity',
    is_public: true
  }
];

const PM_REPORTS_SUPPORTED_PROVIDERS = [
  PM_PROVIDERS.JIRA,
  PM_PROVIDERS.CLUBHOUSE
];

export const PM_REPORTS = [
  {
    type: 'pm',
    name: 'Velocity',
    id: 'issues-velocity',
    is_public: true,
    supportProviders: PM_REPORTS_SUPPORTED_PROVIDERS
  },
  {
    type: 'pm',
    name: 'Investment Profile',
    id: 'issues-investment',
    is_public: true,
    supportProviders: PM_REPORTS_SUPPORTED_PROVIDERS
  },
  {
    type: 'pm',
    name: 'Time Distribution',
    id: 'time-distribution',
    is_public: true,
    supportProviders: PM_REPORTS_SUPPORTED_PROVIDERS
  }
];

export const EMPTY_DEFAULT_REPORT = {
  type: 'metrics',
  name: '',
  id: 'newDashboard',
  is_public: false,
  definition: {
    is_editable: true,
    widgets: []
  }
};
